<app-breadcrumbs></app-breadcrumbs>

@if (isLoading == true) {
  <div class="loading-message">
    Loading (may take a while if database needs to spin up)...
  </div>
}

<div [cfaLoading]="isLoading">

  <h3 class="subheading">Anomalies</h3>


  <p style="font-style: italic">{{this.anomaly_pctle}}th percentile</p>
  <div id="anomalies-table-wrapper">
    <mat-form-field>
      <input matInput (keyup)="applyAnomaliesFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>

    <table id="anomalies-table" #speedTestAnomaliesTable mat-table [dataSource]="speedTestAnomaliesDataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="store">
        <th mat-header-cell *matHeaderCellDef> Store Number </th>
        <!-- <td class="store-number-cell" [routerLink]="['/health/device']" [queryParams]="{storeNumber:location.number}" mat-cell -->
        <td mat-cell *matCellDef="let test"> {{test.store}} </td>
      </ng-container>
      <ng-container matColumnDef="hostname">
        <th mat-header-cell *matHeaderCellDef> Device </th>
        <td mat-cell *matCellDef="let test"> {{test.hostname}} </td>
      </ng-container>
      <ng-container matColumnDef="download">
        <th mat-header-cell *matHeaderCellDef> Download </th>
        <td mat-cell *matCellDef="let test" [ngStyle]="{'color': getPctleColorCoding(test.download, test.pctle_dl)}"> {{test.download}} </td>
      </ng-container>
      <ng-container matColumnDef="pctle_dl">
        <th mat-header-cell *matHeaderCellDef> {{this.anomaly_pctle}}th Pctle </th>
        <td mat-cell *matCellDef="let test"> {{test.pctle_dl}} </td>
      </ng-container>
      <ng-container matColumnDef="upload">
        <th mat-header-cell *matHeaderCellDef> Upload </th>
        <td mat-cell *matCellDef="let test" [ngStyle]="{'color': getPctleColorCoding(test.upload, test.pctle_ul)}"> {{test.upload}} </td>
      </ng-container>
      <ng-container matColumnDef="pctle_ul">
        <th mat-header-cell *matHeaderCellDef> {{this.anomaly_pctle}}th Pctle </th>
        <td mat-cell *matCellDef="let test"> {{test.pctle_ul}} </td>
      </ng-container>
      <ng-container matColumnDef="test_date">
        <th mat-header-cell *matHeaderCellDef> Date </th>
        <td mat-cell *matCellDef="let test"> {{test.test_date}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsAnomalies; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsAnomalies;"></tr>
    </table>
    <mat-paginator #anomalyPaginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>

  <h3 class="subheading">Best/Worst Performers</h3>
  <mat-radio-group>
    <mat-radio-button value="download" color="primary" [(ngModel)]="flag" [checked]="true" (click)="changeTableViewToDownloads()" ngDefaultControl>Download</mat-radio-button>
    <mat-radio-button value="upload" color="primary" [(ngModel)]="flag" (click)="changeTableViewToUploads()" ngDefaultControl>Upload</mat-radio-button>
  </mat-radio-group>

  <div id="top-downloads" [hidden]="!isOnDownloadsTab">
    <div id="best-downloads-table-wrapper">
      <table id="best-downloads-table" #bestDownloadsTable mat-table [dataSource]="bestDownloadsDataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="store">
          <th mat-header-cell *matHeaderCellDef> Store Number </th>
          <td mat-cell *matCellDef="let item"> {{item.store}} </td>
        </ng-container>
        <ng-container matColumnDef="hostname">
          <th mat-header-cell *matHeaderCellDef> Device </th>
          <td mat-cell *matCellDef="let item"> {{item.hostname}} </td>
        </ng-container>
        <ng-container matColumnDef="avg_download">
          <th mat-header-cell *matHeaderCellDef> Avg Download </th>
          <td mat-cell *matCellDef="let item" style="color: var(--badge-online)"> {{item.avg_download}} </td>
        </ng-container>
        <ng-container matColumnDef="carrier">
          <th mat-header-cell *matHeaderCellDef> Carrier </th>
          <td mat-cell *matCellDef="let item"> {{item.carrier}} </td>
        </ng-container>
        <ng-container matColumnDef="net_device_id">
          <th mat-header-cell *matHeaderCellDef> Net Device </th>
          <td mat-cell *matCellDef="let item"> {{item.net_device_id}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsBestDownloads; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsBestDownloads;"></tr>
      </table>
      <mat-paginator #bdPaginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
    </div>

    <div id="worst-downloads-table-wrapper">
      <table id="worst-downloads-table" #worstDownloadsTable mat-table [dataSource]="worstDownloadsDataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="store">
          <th mat-header-cell *matHeaderCellDef> Store Number </th>
          <td mat-cell *matCellDef="let item"> {{item.store}} </td>
        </ng-container>
        <ng-container matColumnDef="hostname">
          <th mat-header-cell *matHeaderCellDef> Device </th>
          <td mat-cell *matCellDef="let item"> {{item.hostname}} </td>
        </ng-container>
        <ng-container matColumnDef="avg_download">
          <th mat-header-cell *matHeaderCellDef> Avg Download </th>
          <td mat-cell *matCellDef="let item" style="color: var(--badge-offline)"> {{item.avg_download}} </td>
        </ng-container>
        <ng-container matColumnDef="carrier">
          <th mat-header-cell *matHeaderCellDef> Carrier </th>
          <td mat-cell *matCellDef="let item"> {{item.carrier}} </td>
        </ng-container>
        <ng-container matColumnDef="net_device_id">
          <th mat-header-cell *matHeaderCellDef> Net Device </th>
          <td mat-cell *matCellDef="let item"> {{item.net_device_id}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsWorstDownloads; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsWorstDownloads;"></tr>
      </table>
      <mat-paginator #wdPaginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </div>

  <div id="top-uploads" [hidden]="isOnDownloadsTab">
    <div id="best-uploads-table-wrapper">
      <table id="best-uploads-table" #bestUploadsTable mat-table [dataSource]="bestUploadsDataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="store">
          <th mat-header-cell *matHeaderCellDef> Store Number </th>
          <td mat-cell *matCellDef="let item"> {{item.store}} </td>
        </ng-container>
        <ng-container matColumnDef="hostname">
          <th mat-header-cell *matHeaderCellDef> Device </th>
          <td mat-cell *matCellDef="let item"> {{item.hostname}} </td>
        </ng-container>
        <ng-container matColumnDef="avg_download">
          <th mat-header-cell *matHeaderCellDef> Avg Upload </th>
          <td mat-cell *matCellDef="let item" style="color: var(--badge-online)"> {{item.avg_upload}} </td>
        </ng-container>
        <ng-container matColumnDef="carrier">
          <th mat-header-cell *matHeaderCellDef> Carrier </th>
          <td mat-cell *matCellDef="let item"> {{item.carrier}} </td>
        </ng-container>
        <ng-container matColumnDef="net_device_id">
          <th mat-header-cell *matHeaderCellDef> Net Device </th>
          <td mat-cell *matCellDef="let item"> {{item.net_device_id}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsBestDownloads; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsBestDownloads;"></tr>
      </table>
      <mat-paginator #buPaginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
    </div>

    <div id="worst-uploads-table-wrapper">
      <table id="worst-uploads-table" #worstUploadsTable mat-table [dataSource]="worstUploadsDataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="store">
          <th mat-header-cell *matHeaderCellDef> Store Number </th>
          <td mat-cell *matCellDef="let item"> {{item.store}} </td>
        </ng-container>
        <ng-container matColumnDef="hostname">
          <th mat-header-cell *matHeaderCellDef> Device </th>
          <td mat-cell *matCellDef="let item"> {{item.hostname}} </td>
        </ng-container>
        <ng-container matColumnDef="avg_upload">
          <th mat-header-cell *matHeaderCellDef> Avg Upload </th>
          <td mat-cell *matCellDef="let item" style="color: var(--badge-offline)"> {{item.avg_upload}} </td>
        </ng-container>
        <ng-container matColumnDef="carrier">
          <th mat-header-cell *matHeaderCellDef> Carrier </th>
          <td mat-cell *matCellDef="let item"> {{item.carrier}} </td>
        </ng-container>
        <ng-container matColumnDef="net_device_id">
          <th mat-header-cell *matHeaderCellDef> Net Device </th>
          <td mat-cell *matCellDef="let item"> {{item.net_device_id}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsWorstUploads; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsWorstUploads;"></tr>
      </table>
      <mat-paginator #wuPaginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </div>

</div>